import api from './api';
import { User } from '../types';

export interface CreateUserDto {
  email: string;
  name: string;
  password: string;
  role?: string;
  avatar?: string;
}

export interface UpdateUserDto {
  email?: string;
  name?: string;
  password?: string;
  role?: string;
  avatar?: string;
  isEmailVerified?: boolean;
  isPremium?: boolean;
}

export const usersService = {
  async getAll(): Promise<User[]> {
    const response = await api.get('/users');
    return response.data.users;
  },

  async getById(id: string): Promise<User> {
    const response = await api.get(`/users/${id}`);
    return response.data.user;
  },

  async create(data: CreateUserDto): Promise<User> {
    const response = await api.post('/users', data);
    return response.data.user;
  },

  async update(id: string, data: UpdateUserDto): Promise<User> {
    const response = await api.put(`/users/${id}`, data);
    return response.data.user;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/users/${id}`);
  },

  async removePremium(id: string): Promise<void> {
    await api.delete(`/subscriptions/users/${id}/premium`);
  },
};
